import { useAuthStore } from '../stores';

export interface PermissionEntry {
  id: number;
  permission: string;
  scope: string;
  granted_by: string | null;
  granted_at: number;
}

export function useCan(permission: string, scope?: string): boolean {
  const currentUser = useAuthStore(s => s.currentUser);
  const permissions = useAuthStore(s => s.permissions);

  if (!currentUser) return false;

  if (!permissions) return false;

  const normalizedScope = scope != null && !scope.includes(':') ? `channel:${scope}` : scope;

  return permissions.some(
    (p) =>
      (p.permission === '*' || p.permission === permission) &&
      (p.scope === '*' || (normalizedScope != null && p.scope === normalizedScope)),
  );
}
